"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @param placement
 */

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

exports["default"] = getMainAxisFromPlacement;